import Loadable from '@townsquare/loadable';
import type { GlobalHomePageRoute, SiteHomePageRoute } from '@townsquare/router/route-types';
import type { RouteContext } from '@townsquare/router/routing-types';
import {
	inferredProjectRoute,
	inferredProjectInboundRoute,
} from '@townsquare/routes/inferred-project';

const InferredProjectViewLoadable = Loadable<RouteContext, object>({
	loader: () =>
		import('./components/InferredProjectView').then(
			({ InferredProjectView }) => InferredProjectView,
		),
	loading: () => null,
});

inferredProjectRoute.component = InferredProjectViewLoadable;
inferredProjectRoute.relayEnvironment = 'agg';
inferredProjectInboundRoute.component = InferredProjectViewLoadable;
inferredProjectInboundRoute.relayEnvironment = 'agg';

export const inferredProjectRouterRoute: SiteHomePageRoute = inferredProjectRoute;
export const inferredProjectInboundRouterRoute: GlobalHomePageRoute = inferredProjectInboundRoute;
